import {
  statusListWithCancellationOption,
  statusListWithNoneOption,
  statusWithNoneAndCancellation,
  statusListWithApproverStates,
  eventStatusListWorkOrder
} from '@domain/shifthandover'
import {StatusWithNoneAndCancellationAndApproverAndWorkOrderStates} from '@hconnect/common/types'
import {RemoveFilterButton} from '@widgets/common-filters'
import {EventStatusLabel} from '@widgets/common-shift-event'
import {union} from 'lodash'
import React from 'react'

import {FilterDropDown} from './FilterDropDown'
import type {CommonFilterDropDownProps} from './FilterDropDown'
import {SelectAllButton} from './SelectAllButton'

// All states that an event can have. This is used on events page 'Status' filter
const statusListWithAllStates: StatusWithNoneAndCancellationAndApproverAndWorkOrderStates[] = union(
  statusListWithCancellationOption,
  statusListWithNoneOption,
  statusWithNoneAndCancellation,
  statusListWithApproverStates,
  eventStatusListWorkOrder
)

export const StatusFilterDropDown: React.FC<
  CommonFilterDropDownProps<StatusWithNoneAndCancellationAndApproverAndWorkOrderStates>
> = (props) => {
  const {selectAll} = props
  return (
    <FilterDropDown
      {...props}
      options={statusListWithAllStates}
      keyName="status"
      customTemplate={(status) => {
        return <EventStatusLabel status={status} />
      }}
      fullWidth={false}
      customDropDownFooter={(keyName) =>
        props.isCollapsible ? null : (
          <>
            <SelectAllButton
              keyName={keyName}
              selectAll={() =>
                selectAll &&
                selectAll(
                  keyName,
                  statusListWithAllStates as unknown as StatusWithNoneAndCancellationAndApproverAndWorkOrderStates[]
                )
              }
            />
            <RemoveFilterButton keyName={keyName} removeFilter={props.removeFilter} />
          </>
        )
      }
    />
  )
}
